import { SIZEGUIDE_SHOW_INFO } from '../Actions/SizeGuide.action';

export const sizeGuide = (state = { showInfo: false, payload: {} }, action) => {
    switch (action.type) {
        case SIZEGUIDE_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}
